import React, { useEffect } from 'react'

import useAuth from '../../auth/useAuth'

import LoaderComponent from '../../components/CommonComponents/LoaderComponent'

// Local sign-out page (the navbar's signOutUrl): clears our session, then goes to the Hub logout.
const LogoutPage = () => {
  const { logout } = useAuth()

  useEffect(() => {
    logout()
  }, []) // eslint-disable-line

  return <LoaderComponent />
}

export default LogoutPage
